/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GetOralExamIdPhotoUrlKind } from './getOralExamIdPhotoUrlKind';

export type GetOralExamIdPhotoUrlParams = {
  kind?: GetOralExamIdPhotoUrlKind;
};
